import React from 'react';
import { Accordion, ButtonVariant, PatternCTASet } from 'mmds';
import {
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
} from '@app/components/ui/drawer/Drawer';
import { CollectionFilterGroup } from './collection-filter-group';
import { CollectionSortGroup } from './collection-sort-group';
import { FiltersDrawerProps } from './types';
import notNull from '@app/lib/helpers/not-null';
import startCase from 'lodash.startcase';
import { Sort } from '@app/[lang]/collections/collection-filtering-toolbar/types';

const defaultSort: Sort = {
    id: 'default',
    sortKey: null,
    reverse: false,
};

const CollectionFiltersDrawer = ({
    availableFilters,
    selectedFilters,
    selectedSort,
    productCount,
    callbacks,
    lang,
}: FiltersDrawerProps) => {
    const sortSelection = defaultSort;
    if (selectedSort && selectedSort.id !== 'default') {
        sortSelection.id = selectedSort.id;
        sortSelection.sortKey = selectedSort.sortKey;
        sortSelection.reverse = selectedSort.reverse;
    }
    const accordionItems = [
        {
            header: 'Sort By',
            content: (
                <CollectionSortGroup
                    options={[
                        {
                            value: 'default',
                            label: 'Recommended',
                        },
                        {
                            value: 'created-desc',
                            label: 'Newest',
                        },
                        {
                            value: 'price-asc',
                            label: 'Price - Low',
                        },
                        {
                            value: 'price-desc',
                            label: 'Price - High',
                        },
                    ]}
                    selectedSort={sortSelection.id}
                    onSelectSort={(selection) => {
                        const sort = {
                            id: selection,
                            sortKey: selection as any,
                            reverse: false,
                        };

                        if (selection === 'recommended') {
                            sort.sortKey = null;
                        }

                        if (selection === 'created-desc') {
                            sort.sortKey = 'CREATED';
                            sort.reverse = true;
                        }

                        if (selection === 'price-asc') {
                            sort.sortKey = 'PRICE';
                        }

                        if (selection === 'price-desc') {
                            sort.sortKey = 'PRICE';
                            sort.reverse = true;
                        }

                        callbacks.applySort(sort);
                    }}
                    lang={lang}
                />
            ),
        },
    ];

    const filterAccordionItems = availableFilters
        .map(({ label, type, values }) => {
            if (values.length === 0) return null;
            return {
                header: label,
                content: (
                    <CollectionFilterGroup
                        type={type}
                        options={values}
                        selectedFilters={selectedFilters}
                        onSelectFilter={(value) => {
                            const alreadySelected = selectedFilters.some(
                                (filter) => {
                                    const filterId = startCase(
                                        filter.id.split('.').pop()
                                    );
                                    const valueId = startCase(
                                        value.id.split('.').pop()
                                    );
                                    return filterId === valueId;
                                }
                            );
                            if (alreadySelected) {
                                callbacks.applyFilters(
                                    selectedFilters.filter((filter) => {
                                        const filterId = startCase(
                                            filter.id.split('.').pop()
                                        );
                                        const valueId = startCase(
                                            value.id.split('.').pop()
                                        );
                                        return filterId !== valueId;
                                    })
                                );
                                return;
                            } else {
                                callbacks.applyFilters([
                                    ...selectedFilters,
                                    value,
                                ]);
                            }
                        }}
                        lang={lang}
                    />
                ),
            };
        })
        .filter(notNull);

    accordionItems.push(...filterAccordionItems);

    const CTAItems = [
        {
            label: 'Clear All',
            variant: 'ghost' as ButtonVariant,
            onClick: () => {
                callbacks.applyFilters([]);
            },
            disabled: selectedFilters.length === 0,
        },
        {
            label: 'Apply',
            variant: 'base' as ButtonVariant,
            onClick: () => {
                callbacks.toggleFilteringUI();
            },
        },
    ];

    return (
        <>
            <DrawerHeader>
                <dt className="mmds-component-one">Filter</dt>
                <dd className="mmds-component-one-detail">
                    {productCount !== 1
                        ? `${productCount} products`
                        : `${productCount} product`}
                </dd>
            </DrawerHeader>
            <DrawerBody>
                <Accordion type="multiple" items={accordionItems} />
            </DrawerBody>
            <DrawerFooter>
                <PatternCTASet set={CTAItems} lang={lang} />
            </DrawerFooter>
        </>
    );
};

export default CollectionFiltersDrawer;
